import { ChartMultipleIcon } from './ChartMultipleIcon';

/**
 * author: Michael Richins
 * id 42E3BF4B-FFE9-449F-AFEE-66F565602A9B
 * name chart-multiple
 * version: 4.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/chart-multiple.svg
 * tags
 * - Math 
 */
export const WidgetMultipleIcon = ChartMultipleIcon;
export default WidgetMultipleIcon